import React from 'react';
import {
  Route, Routes, useLocation, useNavigate,
} from 'react-router-dom';
import { Filter, ToastContainer } from 'vindi-ds-components';

import AdminProvider from '@contexts/admin_context';
import CadastralUpdateModal from '@pages/dashboard/components/CadastralUpdateModal';
import Home from '@pages/home';
import Products from '@pages/product/list';
import NewProduct from '@pages/product/create';
import ShowProduct from '@pages/product/show';
import EditProduct from '@pages/product/edit';
import Reports from '@pages/reports';
import ChargesPendingReport from '@pages/reports/charges_pending';
import SubscriptionsReport from '@pages/reports/subscriptions';
import BillsReport from '@pages/reports/bills';
import Charges from '@pages/reports/charges';
import ContactLogs from '@pages/reports/contact_logs';
import Invoices from '@pages/reports/invoices';
import CustomersRoutes from './admin/customers_routes';

const adminRoutes = [
  { path: '/admin/home', element: <Home /> },
  { path: '/admin/products', element: <Products /> },
  { path: '/admin/products/new', element: <NewProduct /> },
  { path: '/admin/products/:id', element: <ShowProduct /> },
  { path: '/admin/products/:id/edit', element: <EditProduct /> },
  { path: '/admin/reports', element: <Reports /> },
  { path: '/admin/reports/charges_pending', element: <ChargesPendingReport /> },
  { path: '/admin/reports/subscriptions', element: <SubscriptionsReport /> },
  { path: '/admin/reports/bills', element: <BillsReport /> },
  { path: '/admin/reports/charges', element: <Charges /> },
  { path: '/admin/reports/charges_v2', element: <Charges /> },
  { path: '/admin/reports/contact_logs', element: <ContactLogs /> },
  { path: '/admin/reports/invoices', element: <Invoices /> },
  { path: '/admin/subaccount_templates/:id/edit', element: <></> },
  { path: '/admin/subaccount_templates', element: <></> },
  { path: '*', element: <></> },
];

export default function AdminRoutes() {
  const mapReactRouter = Filter.useMapReactRouter({
    useLocation,
    useNavigate,
  });

  return (
    <Filter.FilterConfigProvider {...mapReactRouter}>
      <AdminProvider>
        <ToastContainer>
          <Routes>
            <Route path='/' element={<CadastralUpdateModal />}>
              {adminRoutes.map((route) => (
                <Route key={route.path} path={route.path} element={route.element} />
              ))}
            </Route>
          </Routes>
          <CustomersRoutes />
        </ToastContainer>
      </AdminProvider>
    </Filter.FilterConfigProvider>
  );
}
